import { Box } from '@mui/material'
import { connect } from 'react-redux'
import Datepicker from '../../../common/datePicker'
import DropDownOA from '../../../common/dropDownOA'
import { Item } from '../../../common/snippets'
import { SplitButton } from '../../../common/SplitButton'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { RefreshSvg } from '../../../common/svg/refresh'
import { ReportHeading } from '../common/ReportHeading'
import { useState } from 'react'
import moment from 'moment/moment'
import { appendToUrl, focusElemnt, isEmpty, navigation3 } from '../../../common/helper'
import * as id from '../reportId'
import { useEffect } from 'react'
import * as urls from '../oldReportsUrls'
import { urls as urls2 } from '../../../../components/common/constants'
import { divideInNIntegers } from '../../../../components/common/mathHelper'
import {
  getOnAccountCreditReport,
  getPartyBookingFilter,
  getPartyBookingFilterData,
  getPartyBookingTableData,
} from '../../../../store/reports/reports_action'
import { GetRequest } from '../../../../components/common/api'
import {
  coloumnOnAccountDetailsAll,
  onAccountDetailedColumn1,
} from './const'
import {
  getBranchConfigOrEwbillinfo,
  getPartyList,
  getUserList,
  updateAlertError,
  updateAlert,
  updateModal,
} from '../../../../store/common/common_action'
import { partyAll, partyAs } from '../common/reportConstants'
import { branchAll, userAll } from '../../../common/constants'
import { useAtom, useSetAtom } from 'jotai'
import { globalLoaderAtom } from '../../../../components/common/jotaiState/globalStateAtoms'
import { ChildCompanyListData, fetchChildCompanyListData } from '../../../common/jotaiState/reportStateAtom'

const OnAccountReport = (props) => {
  const {
    data: { common },
    getBranchConfigOrEwbillinfo,
    getPartyList,
    updateAlertError,
    getUserList,
    updateModal,
  } = props
  const setLoader = useSetAtom(globalLoaderAtom)
  const { loginData, citywiseBranchList, userList, partyList, roleRights, companySettings } = common
  const UseFormattedLRinReports = companySettings?.[0]?.UseFormattedLRinReports
  const loginCountryId = companySettings[0]?.DefaultCurrencyID
  const { IsAdmin, IsBranchAdmin, IsMTPLAdmin, intCompanyID, intUserID } = loginData  
  const { AllowGroupofCompanies = 0 } = roleRights?.Table1?.[0] || {}
  const reportName = 'On Account Credit Report'

  const [fromDate, setFromDate] = useState(moment(new Date()))
  const [toDate, setToDate] = useState(moment(new Date()))
  const [selBranch, setSelBranch] = useState()
  const [selPartyAs, setSelPartyAs] = useState(partyAs[0])
  const [selUser, setSelUser] = useState(userAll)
  const [selSendParty, setSelSendParty] = useState(partyAll)
  const [selRecParty, setSelRecParty] = useState(partyAll)
  const [resetFlag, setResetFlag] = useState(false)
  const [isExpanded, setIsExpanded] = useState(false)
  const [isBranchEnable, setIsBranchEnable] = useState(false)
  const [manageColumn, setManageColumn] = useState([])
  const [disableBtn, setDisableBtn] = useState(false)
  const [, fetchChildCompanyList] = useAtom(fetchChildCompanyListData)
  const [ChildCompanyList] = useAtom(ChildCompanyListData)
  const [selCompany, setSelCompany] = useState('')

  useEffect(() => {
    if (AllowGroupofCompanies === 1) {
      const defaultCompany =
        ChildCompanyList.find((v) => v.CompanyID === loginData.intCompanyID) ||
        ChildCompanyList[0];
      setSelCompany(defaultCompany);
    } else {
      setSelCompany({
        CompanyID: loginData.intCompanyID,
        CompanyName: loginData.strCompanyName
      });
    }
  }, [ChildCompanyList, AllowGroupofCompanies]);

  useEffect(() => {
    if (IsAdmin || IsBranchAdmin || IsMTPLAdmin) {
      setIsBranchEnable(true)
    } else {
      if (roleRights?.AllowViewAllBranchReport) {
        setIsBranchEnable(true)
      }
    }
    if (!isEmpty(loginData)) {
      setSelBranch({ BranchName: loginData?.strBranchName, BranchID: loginData?.intBranchID })
      const body = {
        intCompanyID: intCompanyID,
        UserID: intUserID
      }
      fetchChildCompanyList(body)
    }
  }, [loginData])

  useEffect(() => {
    if (!isEmpty(loginData)) {
      let updatedColumns = [...coloumnOnAccountDetailsAll];
      if (loginCountryId === 2) {
        updatedColumns = updatedColumns.filter(
          col => col.field !== 'BookingGST' && col.field !== 'DeliveryGST'
        );
        updatedColumns = updatedColumns.map(col =>
          col.field === 'Valuation'
            ? { ...col, header: 'Insurance\nCharge', pdfHead: 'Insu.\nChrg.' }
            : col
        );
      }
      if (UseFormattedLRinReports === 0 || UseFormattedLRinReports === 1) {
        updatedColumns = updatedColumns.filter(col => col.field !== 'FormattedLRNO');
      }
      if (UseFormattedLRinReports === 2) {
        updatedColumns = updatedColumns.filter(col => col.field !== 'LRNO');
      }
      setManageColumn(updatedColumns);
    }
  }, [loginData, loginCountryId, UseFormattedLRinReports]);

  useEffect(() => {
    if (!isEmpty(roleRights) && !isEmpty(loginData)) {
      setDisableBtn(
        !(
          roleRights?.Table1?.[0]?.AllowViewAllBranchReport ||
          roleRights?.Table1?.[0]?.AllowBranchInchargeRights ||
          loginData?.IsBranchAdmin ||
          loginData?.IsMTPLAdmin ||
          loginData?.IsAdmin
        )
      )
    }
  }, [roleRights, loginData])

  useEffect(() => {
    //api for booking branch list
    const obj = {
      intUserID: 0,
      intCompanyID: loginData?.intCompanyID,
      intBranchID: 0,
      strBranchName: '',
      strBranchCode: '',
      intStateID: 0,
      intCityID: 0,
      intIsActive: -1,
    }
    getBranchConfigOrEwbillinfo(obj, true, 24 * 60 * 60 * 1000)

    //api for party List
    const obj2 = {
      intPartyID: 0,
      intCompanyID: loginData.intCompanyID,
      strPartyName: '',
      strContactPerson: '',
      intCityID: 0,
      intIsCreditParty: -1,
      intIsActive: -1,
      intIsDeleted: 0,
    }
    getPartyList(obj2, false, true, 24 * 60 * 60 * 1000)
    focusElemnt(id.onAcFromDate)
  }, [])

  const groupData = (arr, columns, refundColumns) => {
    let arr1 = []
    let arr2 = []

    arr?.Data?.Table?.map((val) => { arr1.push(val) })
    arr?.Data?.Table1?.map((val) => { arr2.push(val) })

    arr1 = arr1?.map((val, i) => ({ ...val, srNo: i + 1 }))
    arr2 = arr2?.map((val, i) => ({ ...val, srNo: i + 1 }))

    arr1 = arr1?.map((val) => ({
      ...val,
      BookingCity: [val.BookingCity, val.BookingBranch].filter(Boolean).join('\n'),
      DestinationCity: [val.DestinationCity, val.DestinationBranch].filter(Boolean).join('\n'),
      Sender: [val.Sender, val.SenderMobileNo].filter(Boolean).join('\n'),
      Receiver: [val.Receiver, val.ReceiverMobileNo].filter(Boolean).join('\n'),
    }))

    arr2 = arr2?.map((val) => ({
      ...val,
      BookingCity: [val.BookingCity, val.BookingBranch].filter(Boolean).join('\n'),
      DestinationCity: [val.DestinationCity, val.DestinationBranch].filter(Boolean).join('\n'),
      Sender: [val.Sender, val.SenderMobileNo].filter(Boolean).join('\n'),
      SenderGSTN: [val.SenderGSTN, val.SenderEmailID].join('\n'),
      Receiver: [val.Receiver, val.ReceiverMobileNo].filter(Boolean).join('\n'),
      ReceiverGSTN: [val.ReceiverGSTN, val.ReceiverEmailID].filter(Boolean).join('\n'),
      RefundByUser: [val.RefundByUser, val.RefundByBranch].filter(Boolean).join('\n'),
      RefundDateTime: val.RefundDateTime ? moment(val.RefundDateTime).format('DD-MMM-YY\n hh:mm A') : '',
    }))

    const totalRowColSpan = { [columns[0]?.field]: 10 }

    const refundTotalRowColSpan = { [refundColumns[0]?.field]: 13 }

    if (arr2.length === 0) {
      arr2.push(
        loginCountryId !== 2
          ? {
            srNo: '', LRNO: '', ManualLRNo: '', BookingDateTime: '', BookingCity: '',
            BookingBranch: '', DestinationCity: '', DestinationBranch: '', Receiver: '',
            ReceiverMobileNo: '', ReceiverGSTN: '', ReceiverEmailID: '', Sender: '',
            SenderMobileNo: '', SenderGSTN: '', SenderEmailID: '', BookedBy: '',
            ItemDetails: '', Status: '', RefundByUser: '', RefundByBranch: '', RefundDateTime: '',
            Items: 0, Freight: 0, DocumentCharges: 0, CartageAmount: 0, HamaliCharges: 0,
            OperatorHamaliChg: 0, Valuation: 0, OtherCharge: 0, BookingGST: 0,
            RefundAmount: 0, Outstanding: 0, IsRefund: 1,
          }
          : {
            srNo: '', LRNO: '', ManualLRNo: '', BookingDateTime: '', BookingCity: '',
            BookingBranch: '', DestinationCity: '', DestinationBranch: '', Receiver: '',
            ReceiverMobileNo: '', ReceiverGSTN: '', ReceiverEmailID: '', Sender: '',
            SenderMobileNo: '', SenderGSTN: '', SenderEmailID: '', BookedBy: '',
            ItemDetails: '', Status: '', RefundByUser: '', RefundByBranch: '', RefundDateTime: '',
            Items: 0, Freight: 0, DocumentCharges: 0, CartageAmount: 0, HamaliCharges: 0,
            OperatorHamaliChg: 0, Valuation: 0, OtherCharge: 0,
            RefundAmount: 0, Outstanding: 0, IsRefund: 1,
          }
      )
    }

    // Totals for arr1
    let TotalItems = 0, TotalFreight = 0, TotalDocumentCharges = 0, TotalCartageAmount = 0
    let TotalHamaliCharges = 0, TotalOperatorHamaliChg = 0, TotalValuation = 0, TotalOtherCharge = 0
    let TotalBookingGST = 0, TotalDelCartage = 0, TotalDelHamali = 0, TotalDemurrageChg = 0
    let TotalDeliveryGST = 0, TotalNetAmount = 0, TotalOutstanding = 0

    arr1?.map((val) => {
      TotalItems += Number(val.Items)
      TotalFreight += Number(val.Freight)
      TotalDocumentCharges += Number(val.DocumentCharges)
      TotalCartageAmount += Number(val.CartageAmount)
      TotalHamaliCharges += Number(val.HamaliCharges)
      TotalOperatorHamaliChg += Number(val.OperatorHamaliChg)
      TotalValuation += Number(val.Valuation)
      TotalOtherCharge += Number(val.OtherCharge)
      TotalBookingGST += Number(val.BookingGST)
      TotalDelCartage += Number(val.DelCartage)
      TotalDelHamali += Number(val.DelHamali)
      TotalDemurrageChg += Number(val.DemurrageChg)
      TotalDeliveryGST += Number(val.DeliveryGST)
      TotalNetAmount += Number(val.NetAmount)
      TotalOutstanding += Number(val.Outstanding)
    })

    arr1.push(
      loginCountryId !== 2
        ? {
          [columns[0].field]: `Total: Credit Delivery`,
          Items: TotalItems, Freight: TotalFreight, DocumentCharges: TotalDocumentCharges,
          CartageAmount: TotalCartageAmount, HamaliCharges: TotalHamaliCharges,
          OperatorHamaliChg: TotalOperatorHamaliChg, Valuation: TotalValuation,
          OtherCharge: TotalOtherCharge, BookingGST: TotalBookingGST, NetAmount: TotalNetAmount,
          DelHamali: TotalDelHamali, DelCartage: TotalDelCartage, DemurrageChg: TotalDemurrageChg,
          DeliveryGST: TotalDeliveryGST, Outstanding: TotalOutstanding,
          isTotal: true, IsRefund: 0, dataType: 'total', colSpan: totalRowColSpan,
        }
        : {
          [columns[0].field]: `Total: Credit Delivery`,
          Items: TotalItems, Freight: TotalFreight, DocumentCharges: TotalDocumentCharges,
          CartageAmount: TotalCartageAmount, HamaliCharges: TotalHamaliCharges,
          OperatorHamaliChg: TotalOperatorHamaliChg, Valuation: TotalValuation,
          OtherCharge: TotalOtherCharge, NetAmount: TotalNetAmount,
          DelHamali: TotalDelHamali, DelCartage: TotalDelCartage, DemurrageChg: TotalDemurrageChg,
          Outstanding: TotalOutstanding,
          isTotal: true, IsRefund: 0, dataType: 'total', colSpan: totalRowColSpan,
        }
    )

    const lengths = divideInNIntegers(columns.length, 4);

    let index = 0;
    const pickedHeaders = [];

    lengths.forEach((span) => {
      pickedHeaders.push(columns[index]?.field);
      index += span;
    });
    arr1.unshift({
      colSpan: Object.fromEntries(
        pickedHeaders.map((key, i) => [key, lengths[i]])
      ),
      align: {
        [pickedHeaders[0]]: 'left',
        [pickedHeaders[1]]: 'center',
        [pickedHeaders[2]]: 'center',
        [pickedHeaders[3]]: 'right',
      },

      [pickedHeaders[0]]: `Source Branch : ${selBranch?.BranchName || 'All'}`,
      [pickedHeaders[1]]: `Booked By User: ${selUser?.UserName || 'All'}`,
      [pickedHeaders[2]]: `Show Party As: ${selPartyAs?.name || 'Any'}`,
      [pickedHeaders[3]]: `Transactions: Credit Delivery`,

      dataType: 'subHeader',
      isSubHeading: true,
    });

    arr2 = arr2.map((row, i) => {
      if (row.LRNO) return { ...row, dataType: 'entry', srNo: i + 1 }
      return { ...row };
    })

    // Totals for arr2
    TotalItems = 0; TotalFreight = 0; TotalDocumentCharges = 0; TotalCartageAmount = 0
    TotalHamaliCharges = 0; TotalOperatorHamaliChg = 0; TotalValuation = 0; TotalOtherCharge = 0
    TotalBookingGST = 0; TotalOutstanding = 0
    let TotalRefundAmount = 0

    arr2?.map((val) => {
      TotalItems += Number(val.Items)
      TotalFreight += Number(val.Freight)
      TotalDocumentCharges += Number(val.DocumentCharges)
      TotalCartageAmount += Number(val.CartageAmount)
      TotalHamaliCharges += Number(val.HamaliCharges)
      TotalOperatorHamaliChg += Number(val.OperatorHamaliChg)
      TotalValuation += Number(val.Valuation)
      TotalOtherCharge += Number(val.OtherCharge)
      TotalBookingGST += Number(val.BookingGST)
      TotalRefundAmount += Number(val.RefundAmount)
      TotalOutstanding += Number(val.Outstanding)
    })

    arr2.push(
      loginCountryId !== 2
        ? {
          [refundColumns[0].field]: `Total: Refund`,
          Items: TotalItems, Freight: TotalFreight, DocumentCharges: TotalDocumentCharges,
          CartageAmount: TotalCartageAmount, HamaliCharges: TotalHamaliCharges,
          OperatorHamaliChg: TotalOperatorHamaliChg, Valuation: TotalValuation,
          OtherCharge: TotalOtherCharge, BookingGST: TotalBookingGST,
          RefundAmount: TotalRefundAmount, Outstanding: TotalOutstanding,
          isTotalRefund: true, IsRefund: 1, dataType: 'total',
          colSpan: refundTotalRowColSpan
        }
        : {
          [refundColumns[0].field]: `Total: Refund`,
          Items: TotalItems, Freight: TotalFreight, DocumentCharges: TotalDocumentCharges,
          CartageAmount: TotalCartageAmount, HamaliCharges: TotalHamaliCharges,
          OperatorHamaliChg: TotalOperatorHamaliChg, Valuation: TotalValuation,
          OtherCharge: TotalOtherCharge, RefundAmount: TotalRefundAmount,
          Outstanding: TotalOutstanding,
          isTotalRefund: true, IsRefund: 1, dataType: 'total',
          colSpan: refundTotalRowColSpan
        }
    )

    const refundLengths = divideInNIntegers(refundColumns.length, 4);

    let refundIndex = 0;
    const refundPickedHeaders = [];

    refundLengths.forEach((span) => {
      refundPickedHeaders.push(refundColumns[refundIndex]?.field);
      refundIndex += span;
    });
    arr2.unshift({
      colSpan: Object.fromEntries(
        refundPickedHeaders.map((key, i) => [key, refundLengths[i]])
      ),
      align: {
        [refundPickedHeaders[0]]: 'left',
        [refundPickedHeaders[1]]: 'center',
        [refundPickedHeaders[2]]: 'center',
        [refundPickedHeaders[3]]: 'right',
      },

      [refundPickedHeaders[0]]: `Source Branch : ${selBranch?.BranchName || 'All'}`,
      [refundPickedHeaders[1]]: `Booked By User: ${selUser?.UserName || 'All'}`,
      [refundPickedHeaders[2]]: `Show Party As: ${selPartyAs?.name || 'Any'}`,
      [refundPickedHeaders[3]]: `Transactions: Refund`,

      dataType: 'subHeader',
      isSubHeading: true,

    });

    arr1 = arr1.map((row, i) => {
      if (row.isTotal) return { ...row, dataType: 'total' }
      if (row.isSubHeading) return { ...row, dataType: 'subHeader' }
      if (row.LRNO) return { ...row, dataType: 'entry' }
      return row
    })
    const temp = {
      arr1: arr1,
      arr2: arr2,
    }
    return temp
  }

  const handleClick2 = () => {
    let url = urls.amountCreditReport
    const urlData = urls.amountCreditReportParams
    urlData.chk = loginData.BusCrsCheckSum
    urlData.intSelBranchID = selBranch.BranchID
    urlData.strSelBranch = selBranch.BranchName
    urlData.intSenderPartyID = selSendParty.PartyID
    urlData.intRecPartyID = selRecParty.PartyID
    urlData.intSelUserID = selUser.UserID
    urlData.FromDate = fromDate.format('YYYY-MM-DD')
    urlData.ToDate = toDate.format('YYYY-MM-DD')
    urlData.intAllowExportToExcel = 1
    urlData.PartyAsId = selPartyAs.id
    url = appendToUrl(url, urlData)
    window.open(url, '_blank')
  }
  const handleBranchSelect = (e) => {
    //api for userList
    const obj1 = {
      intUserID: 0,
      intCompanyID: loginData.intCompanyID,
      intBranchID: e?.BranchID,
      strUserName: '',
      strLoginID: '',
      strPassword: '',
      strContactNo: '',
      intRoleID: 0,
      intIsActive: -1,
    }
    getUserList(obj1)
  }

  const criteriaHeaders = [
    { field: 'selCompany', header: 'Company', textAlign: 'left' },
    { field: 'fromDate', header: 'From Booking Date', textAlign: 'left' },
    { field: 'toDate', header: 'To Booking Date', textAlign: 'left' },
    { field: 'selBranch', header: 'Booking Branch', textAlign: 'left' },
    { field: 'selUser', header: 'User', textAlign: 'left' },
    { field: 'selSendParty', header: 'Sender Party', textAlign: 'left' },
    { field: 'selRecParty', header: 'Receiver Party', textAlign: 'left' },
    { field: 'selPartyAs', header: 'Party As', textAlign: 'left' },
  ]
  const criteriaData = {
    selCompany: selCompany?.CompanyName || '',
    fromDate: fromDate.format('DD-MM-YYYY') || '',
    toDate: toDate.format('DD-MM-YYYY') || '',
    selBranch: selBranch?.BranchName || '',
    selUser: selUser?.UserName || '',
    selSendParty: selSendParty?.Party || '',
    selRecParty: selRecParty?.Party || '',
    selPartyAs: selPartyAs?.name || '',
    dataType: 'entry',
  }

  const handleClick1 = () => {
    const diffDays = Math.abs(toDate.diff(fromDate, 'days'))
    const isAllSelected = selBranch.BranchID === 0 || selUser.UserID === 0
    if (isAllSelected && diffDays > 15) {
      updateAlertError({ show: true, msg: 'For All selection, date range cannot exceed 15 days', nextId: '' })
    } else if (!isAllSelected && diffDays > 31) {
      updateAlertError({ show: true, msg: 'This report cannot be taken for more than 31 days', nextId: '' })
    } else {
      setIsExpanded(true)
      setLoader(true)
      const obj = {
        CompanyID: selCompany?.CompanyID,
        BranchID: selBranch.BranchID,
        FromDate: fromDate.format('YYYY-MM-DD'),
        ToDate: toDate.format('YYYY-MM-DD'),
        UserID: selUser.UserID,
        SenderPartyID: selSendParty.PartyID,
        RecPartyID: selRecParty.PartyID,
        partyas: selPartyAs.id,
      }

      const selectedColumns = manageColumn.filter(obj => obj.isSelected).map(col => ({
        ...col,
        align: col.headerSx?.textAlign || 'left',
        header: col.pdfHead || col.header,
        export: col.pdfHead,
        exportHead: col.exportHead || col.pdfHead || col.header,
        pdfHead: col.pdfHead || col.header,
        weight: 40,
        dataType: 'header'
      }))

      GetRequest(urls2.getOnAccountCreditReport, obj)
        .then((res) => {
          setLoader(false)
          if (res.status === 'Success') {
            const onAccountReportData = res
            let tempData = null
            if (onAccountReportData?.Data?.Table?.length > 0) {
              tempData = groupData(onAccountReportData, selectedColumns, onAccountDetailedColumn1);
            }
            const refundColumns = onAccountDetailedColumn1.map(col => ({
              ...col,
              field: col.field,
              header: col.exportHead,
              exportHead: col.exportHead,
              align: col.align,
              dataType: 'header',
              weight: 40,
            }))

            const reportPayload = {
              reportName: reportName,
              isMultiTable: true,
              tables: [
                {
                  criteriaHeaders: criteriaHeaders,
                  criteriaData: [criteriaData],
                  tableData: tempData.arr1,
                  mainHeader: selectedColumns,
                  serialNokey: 'srNo',
                },
                {
                  tableData: tempData.arr2,
                  mainHeader: refundColumns,
                  serialNokey: 'srNo',
                }
              ],
              isShowManageColumn: true,
              manageColumnID: `onAccount_${Date.now()}`,
            }

            const rid = Date.now().toString()
            if (!window.generatedReports) window.generatedReports = {}
            window.generatedReports[rid] = reportPayload
            window.open(`/view-report?rid=${rid}`, "_blank")
          } else {
            updateAlert({ show: true, msg: 'No Data Found' })
          }
        })
        .catch((err) => {
          setLoader(false)
          updateAlert({ show: true, msg: err })
        })
    }
  }
  const branchList = Array.isArray(citywiseBranchList) ? citywiseBranchList : []

  return (
    <>
      <Item sx={{ padding: '0' }} className="reports">
        <ReportHeading reportName={reportName} />
        <Box sx={sx.reportFlex}>
          <Item sx={sx.itemsx}>
            <DropDownOA
              id={id.selectCompnay}
              nextId={id.fromDate}
              label="Selected Company"
              data={ChildCompanyList}
              defaultvalue={selCompany?.CompanyName}
              disabled={AllowGroupofCompanies === 1 ? false : true}
              onSelect={(e) => {
                setSelCompany(e)
                focusElemnt(id.fromDate)
              }}
              dataKey={`CompanyName`}
              idKey={`CompanyID`}
              minWidth="300px"
            />
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              label={'From BookingDate'}
              minWidth="220px"
              name={'from_date'}
              id={id.onAcFromDate}
              dateChange={(date) => {
                setFromDate(date)
                focusElemnt(id.toDate)
              }}
            />
          </Item>
          <Item sx={sx.itemsx} className="input--container bookingDatePicker">
            <Datepicker
              label={'To BookingDate'}
              minWidth="200px"
              name={'to_date'}
              id={id.toDate}
              dateChange={(date) => {
                setToDate(date)
                focusElemnt(id.onAcBookingBranch)
              }}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, flexGrow: 1 }}>
            <DropDownOA
              label={'Booking Branch'}
              id={id.onAcBookingBranch}
              defaultvalue={selBranch?.BranchName}
              data={
                roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 1 && roleRights?.Table1?.[0]?.AllowViewAllBranchReport == 0
                  ? [branchAll, ...branchList].filter((val) => val.CityID == loginData?.intBranchCityID)
                  : [branchAll, ...branchList]
              }
              dataKey={`BranchName`}
              idKey={`BranchID`}
              onSelect={(e) => {
                handleBranchSelect(e)
                setSelBranch(e)
              }}
              //disabled={!isBranchEnable}
              width="100%"
              nextId={id.onAcUser}
              prevId={id.toDate}
              resetFlag={resetFlag}
              disabled={disableBtn && roleRights?.Table1?.[0]?.AllowViewAllBranchOfCityReport == 0}
            />
          </Item>
          <Item sx={{ ...sx.itemsx, flexGrow: 1 }}>
            <DropDownOA
              id={id.onAcUser}
              defaultvalue={userAll.UserName}
              label={'Select User'}
              data={[userAll, ...userList] || []}
              dataKey={`UserName`}
              idKey={`UserID`}
              onSelect={(obj) => setSelUser(obj)}
              nextId={id.onAcParty}
              prevId={id.onAcBookingBranch}
              resetFlag={resetFlag}
              width="98%"
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              label={' Select Party'}
              id={id.onAcParty}
              defaultvalue={partyAll.Party}
              nextId={id.recParty}
              prevId={id.onAcUser}
              dataKey={`Party`}
              idKey={`PartyID`}
              data={[partyAll, ...partyList] || []}
              onSelect={(e) => {
                setSelSendParty(e)
              }}
              resetFlag={resetFlag}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              label={'Receiver Party'}
              // minWidth="300px"
              id={id.recParty}
              nextId={id.onAcPartyAs}
              defaultvalue={partyAll.Party}
              prevId={id.onAcParty}
              dataKey={`Party`}
              idKey={`PartyID`}
              data={[partyAll, ...partyList] || []}
              onSelect={(e) => {
                setSelRecParty(e)
              }}
              width="100%"
            />
          </Item>
          <Item sx={sx.itemsx}>
            <DropDownOA
              //minWidth="300px"
              id={id.onAcPartyAs}
              defaultvalue={partyAs[0].name}
              label={'Party As'}
              data={partyAs || []}
              width="100%"
              searchPlaceholder={`Search Party Name`}
              dataKey={`name`}
              idKey={`id`}
              onSelect={(e) => {
                setSelPartyAs(e)
              }}
              nextId={id.onAcSplitButton}
              prevId={id.recParty}
              resetFlag={resetFlag}
            />
          </Item>
          <Item sx={sx.itemsx} onKeyDown={(e) => navigation3(e, isExpanded ? 'onACExcelButton' : id.onAcFromDate, () => handleClick1())}>
            <SplitButton
              options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}              
              id1={id.onAcSplitButton}
              onClick1={handleClick1}
              onClick2={handleClick2}
            />
          </Item>
          <Item
            sx={{ ...sx.itemsx }}
            onClick={() => {
              setResetFlag(!resetFlag)
            }}
          >
            <RefreshSvg />
          </Item>
        </Box>
      </Item>
    </>
  )
}
const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
  getPartyBookingFilter,
  getPartyBookingFilterData,
  getPartyBookingTableData,
  getOnAccountCreditReport,
  getBranchConfigOrEwbillinfo,
  getPartyList,
  updateAlertError,
  getUserList,
  updateModal,
}
export default connect(mapStateToProps, mapDispatchToProps)(OnAccountReport)